export default class FlashMessages{
  constructor() {
    this.init();
  }

  init() {
    //only print messages in the top iframe
    if(window.isBaseTemplate) {
      var flashMessages = window.localStorage.getItem('flashMessages');

      flashMessages = (flashMessages) ? JSON.parse(flashMessages) : [];

      flashMessages.forEach((item) => {
        let label = item.label
        if (item.label === 'danger') {
          label = 'error';
        }
        label = label.charAt(0).toUpperCase() + label.slice(1);
        $.toast({
          heading: label,
          text: item.message,
          icon: label.toLowerCase(),
          hideAfter: 10000
        });
      });
      window.localStorage.setItem('flashMessages', '[]');
    }
  }
}
